package search.nestedObjects

import search.searchFilterStores.ActiveKeywordsStore

class ActiveNestedSearchKeywordStore : ActiveKeywordsStore()
